import { axiosGET, axiosPOST } from '../../Helpers/TypeAxios'
import { urlParseParams } from "../../Helpers/helpFunction";

const routerRoot = 'statistic';

export default class Statistic {
  GetStockTicker(ticker: string, data: any) {
    const stringUrl = urlParseParams(data);
    return axiosGET(`/${routerRoot}/stock/trading/${ticker}?${stringUrl}`, {})
  }
}